/** Simple stamina pool for enemies — gates dash usage and regenerates over time. */

export interface EnemyStaminaConfig {
  max: number;
  regenPerSec: number;
}

/** Per-enemy stamina pool that gates dash and block usage, with passive regeneration. */
export class EnemyStamina {
  private _current: number;
  private readonly _max: number;
  private readonly _regenPerMs: number;

  constructor(config: EnemyStaminaConfig) {
    this._max = config.max;
    this._current = config.max;
    this._regenPerMs = config.regenPerSec / 1000;
  }

  get current(): number { return this._current; }
  get max(): number { return this._max; }

  /** Attempt to consume stamina. Returns true if sufficient stamina was available. */
  consume(cost: number): boolean {
    if (this._current < cost) return false;
    this._current -= cost;
    return true;
  }

  /** Regenerate stamina over time. Call every frame with delta in ms. */
  update(delta: number): void {
    if (this._current < this._max) {
      this._current = Math.min(this._max, this._current + this._regenPerMs * delta);
    }
  }
}
